import { render, staticRenderFns } from "./text-message.vue?vue&type=template&id=2759cda4&scoped=true"
import script from "./text-message.vue?vue&type=script&lang=js"
export * from "./text-message.vue?vue&type=script&lang=js"
import style0 from "./text-message.vue?vue&type=style&index=0&id=2759cda4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2759cda4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/LRL_LCDDMAC_eMSL_CFC/LRL_LCDDMAC_eMSL_CFC/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2759cda4')) {
      api.createRecord('2759cda4', component.options)
    } else {
      api.reload('2759cda4', component.options)
    }
    module.hot.accept("./text-message.vue?vue&type=template&id=2759cda4&scoped=true", function () {
      api.rerender('2759cda4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/se/view/text-message.vue"
export default component.exports